<div *ngIf="isNotReturn" [ngClass]="{
    'right-copy-switch-button':side === LensSide.RIGHT,
    'left-copy-switch-button':side === LensSide.LEFT}">
  <app-lens-side-circle *ngIf="side == 'RIGHT'" [side]="side"
                        [ngClass]="{'circle':side === LensSide.RIGHT}"></app-lens-side-circle>
  <app-copy-switch-button [side]="side" (copyEmit)="copy($event)"
                          (switchEmit)="switch($event)"></app-copy-switch-button>
  <app-lens-side-circle *ngIf="side == 'LEFT'" [side]="side"
                        [ngClass]="{'circle':side === LensSide.RIGHT}"></app-lens-side-circle>
</div>

<div>
  <form [formGroup]="form">

    <div class="d-flex">
      <div class="d-flex final-lens-parameter-commission">
        <label>{{"newOrder.finalLens.commission" | translate}}<span class="span-label-required"></span>
          <input formControlName="commission" class="form-control parameter-input"
                 [placeholder]="'newOrder.finalLens.commission' | translate"
                 [ngClass]="{required: true, error: form.get('commission').errors && (form.get('commission').touched || (form.get('commission').dirty))}"/>
        </label>
      </div>
    </div>

    <div class="lens-type">
      <h2>{{"newOrder.finalLens.lensType.title" | translate}}</h2>
      <mat-radio-group formControlName="lensType">
        <mat-radio-button [value]="LensType.HARD" (click)="setTypeLens(true)" class="mat-radio-button-first">
          {{"newOrder.finalLens.lensType.hard" | translate}}
        </mat-radio-button>
        <mat-radio-button [value]="LensType.SOFT" (click)="setTypeLens(false)">
          {{"newOrder.finalLens.lensType.soft" | translate}}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="d-flex">
      <div class="d-flex final-lens-parameter-autocomplete" *ngIf="this.lensFilter.backSides">
        <label class="input-wrapper-chevron-down">{{"newOrder.finalLens.backsideV2" | translate}}<span
          class="span-label-required"></span>
          <input type="text" class="form-control parameter-input"
                 [placeholder]="'common.hints.pleaseSelect' | translate" [matAutocomplete]="backSideAutocomplete"
                 [id]="'backSideAutocompleteFinalLens' + side" formControlName="backSide"
                 #backSideInput
                 (keyup.backspace)="backspaceBackSide()"
                 [ngClass]="{required: true, error: form.get('backSide').errors && (form.get('backSide').touched || (form.get('backSide').dirty))}">
        </label>
        <mat-autocomplete #backSideAutocomplete="matAutocomplete">
          <mat-option *ngFor="let backSide of filteredBackSide | async" [value]="backSide.name"
                      (click)="selectBackSide(backSide); backSideInput.blur()">
            {{backSide.name}}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="d-flex final-lens-parameter-autocomplete" *ngIf="this.lensFilter.families">
        <label class="input-wrapper-chevron-down">{{"newOrder.finalLens.family" | translate}}<span
          class="span-label-required"></span>
          <input type="text" class="form-control parameter-input"
                 [placeholder]="'common.hints.pleaseSelect' | translate" [matAutocomplete]="lensFamilyAutocomplete"
                 [id]="'lensFamilyAutocompleteFinalLens' + side" formControlName="lensFamily"
                 #lensFamilyInput
                 (keyup.backspace)="backspaceLensFamily()"
                 [ngClass]="{required: true, error: form.get('lensFamily').errors && (form.get('lensFamily').touched || (form.get('lensFamily').dirty))}">
        </label>
        <mat-autocomplete #lensFamilyAutocomplete="matAutocomplete" [panelWidth]="300">
          <mat-option *ngFor="let lensFamily of filteredLensFamily | async" [value]="lensFamily.name"
                      (click)="selectFamily(lensFamily); lensFamilyInput.blur()">
            {{lensFamily.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="d-flex">
      <div class="d-flex final-lens-parameter-autocomplete" *ngIf="this.lensFilter.materials">
        <label class="input-wrapper-chevron-down">{{"newOrder.finalLens.material" | translate}}<span
          class="span-label-required"></span>
          <input type="text" class="form-control parameter-input"
                 [placeholder]="'common.hints.pleaseSelect' | translate" [matAutocomplete]="materialAutocomplete"
                 [id]="'materialAutocompleteFinalLens' + side" formControlName="material"
                 #materialInput
                 (keyup.backspace)="backspaceMaterial()"
                 [ngClass]="{required: true, error: form.get('material').errors && (form.get('material').touched || (form.get('material').dirty))}">
        </label>
        <mat-autocomplete #materialAutocomplete="matAutocomplete" [panelWidth]="211">
          <mat-option *ngFor="let material of filteredMaterial | async" [value]="material.name"
                      (click)="selectMaterial(material); materialInput.blur()">
            {{material.name}}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="d-flex final-lens-parameter-autocomplete" *ngIf="this.lensFilter.colors">
        <label class="input-wrapper-chevron-down">{{"newOrder.finalLens.color" | translate}}<span
          class="span-label-required"></span>
          <input type="text" class="form-control parameter-input"
                 [placeholder]="'common.hints.pleaseSelect' | translate" [matAutocomplete]="colorAutocomplete"
                 [id]="'colorAutocompleteFinalLens' + side" formControlName="color"
                 #colorInput
                 (keyup.backspace)="backspaceColor()"
                 [ngClass]="{required: true, error: form.get('color').errors && (form.get('color').touched || (form.get('color').dirty))}">
        </label>
        <mat-autocomplete #colorAutocomplete="matAutocomplete">
          <mat-option *ngFor="let color of filteredColor | async" [value]="color.name"
                      (click)="setColor(color); colorInput.blur()">
            {{color.name}}<span class="default-color" *ngIf="defaultColor && defaultColor.name === color.name"></span>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <div class="d-flex info">
      <a href="https://hecht-contactlinsen.de/dateien/Materialuebersicht_FCL_WCL_0291-2022-07-V5.html" target="_blank">
        {{'newOrder.finalLens.moreMaterials' | translate}}
        <fa-icon [icon]="arrow"></fa-icon>
      </a>

      <!--<span><fa-icon [icon]="circle" style="font-size: 10px;"></fa-icon>{{'newOrder.finalLens.colorHintV2' | translate}}</span>-->
      <span *ngIf="defaultColor && defaultColor.name">{{defaultColor.name}}{{'newOrder.finalLens.colorHintV2' | translate}}</span>
    </div>
  </form>
  <div class="radio-panel">
    <div class="return" *ngIf="showReturn">
      <h2>{{"newOrder.finalLens.return.title" | translate}}</h2>
      <mat-radio-group [(ngModel)]="isReturn">
        <mat-radio-button [value]="true" class="mat-radio-button-first">{{"newOrder.finalLens.return.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"newOrder.finalLens.return.no" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="return" *ngIf="showReturn && showEase">
      <h2>{{"newOrder.finalLens.ease.title" | translate}}</h2>
      <mat-radio-group [(ngModel)]="easeDouble" [disabled]="isReturn">
        <mat-radio-button [value]="true" class="mat-radio-button-first">{{"newOrder.finalLens.ease.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"newOrder.finalLens.ease.no" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <app-validation-error [form]="form"></app-validation-error>
</div>

<div *ngIf="features?.default" style="display:flex; margin-top: 25px;">
  <h2>{{"newOrder.hechtProposal.response.additionalOptions" | translate}}</h2>
  <div style="margin: 7px 12px">
    <mat-checkbox [checked]="showAdditionalOptions" [disabled]="disableAdditionalOptions"
                  (change)="toggleFeatures()"></mat-checkbox>
  </div>
  <h2 *ngIf="features?.individual" style="margin-left: 26px">{{'newOrder.finalLens.individual' | translate}}</h2>
  <div style="margin: 7px 12px" *ngIf="features?.individual">
    <mat-checkbox [(ngModel)]="isIndividual" (change)="toggleIndividual()"></mat-checkbox>
  </div>
</div>

<div style="margin-top: -10px;">
  <form [formGroup]="lensDetailsForm" class="lens-details-form">

    <div *ngIf="!isIndividual">
      <div *ngFor="let feature of features.default; let i = index;" style="display: inline-block">
        <div *ngIf="(feature.required || showAdditionalOptions)"
             [ngClass]="(feature.required || showAdditionalOptions) ? 'features' : 'hidden-features'">
          <div *ngIf="feature.type === 'RANGE'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <input type="text" class="form-control range-feature" [name]="feature.name"
                     [id]="'feature#' + i" (keydown.enter)="nextInput('feature#' + i)"
                     [formControlName]="feature.name" (blur)="setValueWithFormat(feature.name)"
                     [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
            </label>
            <div class="info">
              <img src="assets/img/icons/info.svg"
                   [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(feature.rangeMin,feature.rangeMax)"
                   matTooltipPosition="above">
            </div>
          </div>
          <div *ngIf="feature.type === 'ENUM'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <span *ngIf="!feature.required"></span>
              <mat-select class="form-control enum-feature"
                          #select [formControlName]="feature.name" [id]="'feature#' + i"
                          (focus)="select.open()" (valueChange)="select.close()" (keydown.enter)="nextInput('feature#' + i);"
                          [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
                <mat-option name=""></mat-option>
                <mat-option *ngFor="let value of toEnumFeature(feature).values" [value]="value.name">{{value.name}}
                </mat-option>
              </mat-select>
            </label>
          </div>
          <div *ngIf="feature.type === 'FIXED'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <input type="text" [attr.disabled]="true" class="form-control fixed-feature"
                     [name]="feature.name" [formControlName]="feature.name"
                     [id]="'feature#' + i" (keydown.enter)="nextInput('feature#' + i)"
                     [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
            </label>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isIndividual && features?.individual">
      <div *ngFor="let feature of features.individual; let i = index;" style="display: inline-block">
        <div *ngIf="(feature.required || showAdditionalOptions)"
             [ngClass]="(feature.required || showAdditionalOptions) ? 'features' : 'hidden-features'">
          <div *ngIf="feature.type === 'RANGE'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <input type="text" class="form-control range-feature" [name]="feature.name"
                     [id]="'feature#' + i" (keydown.enter)="nextInput('feature#' + i)"
                     [formControlName]="feature.name" (focus)="setValueWithFormat(feature.name)"
                     [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
            </label>
            <div class="info">
              <img src="assets/img/icons/info.svg"
                   [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(feature.rangeMin,feature.rangeMax)"
                   matTooltipPosition="above">
            </div>
          </div>
          <div *ngIf="feature.type === 'ENUM'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <span *ngIf="!feature.required"></span>
              <mat-select class="form-control enum-feature"
                          #select [formControlName]="feature.name" [id]="'feature#' + i"
                          (focus)="select.open()" (valueChange)="select.close()" (keydown.enter)="nextInput('feature#' + i);"
                          [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
                <mat-option name=""></mat-option>
                <mat-option *ngFor="let value of toEnumFeature(feature).values" [value]="value.name">{{value.name}}
                </mat-option>
              </mat-select>
            </label>
          </div>
          <div *ngIf="feature.type === 'FIXED'" class="d-flex">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">
              {{getTranslation(feature) | async}}
              <span *ngIf="feature.required" class="span-label-required"></span>
              <input type="text" disabled="true" class="form-control fixed-feature"
                     [name]="feature.name" [formControlName]="feature.name"
                     [id]="'feature#' + i" (keydown.enter)="nextInput('feature#' + i)"
                     [ngClass]="{required:feature.required, error: lensDetailsForm.get(feature.name).errors && (lensDetailsForm.get(feature.name).touched || (lensDetailsForm.get(feature.name).dirty))}">
            </label>
          </div>
        </div>
      </div>
    </div>

  </form>
  <app-validation-error [form]="lensDetailsForm"></app-validation-error>
  <div *ngIf="lensDetailsForm.valid">
    <app-validation-warning [backSideId]="backSideId" [lensFamilyId]="lensFamilyId"
                            [additionalOptions]="additionalOptions"></app-validation-warning>
  </div>
</div>
<div class="d-flex" *ngIf="showDesireDate">
  <div class="date-block" *ngIf="checkProductionDateVariables()">
    <label>{{"pdf.desireDate" | translate}}</label>
    <div class="date-panel">
      <input
        matInput
        [matDatepickerFilter]="dateFilter"
        [matDatepicker]="picker"
        [(ngModel)]="desireDate"
        class="date-input">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker-toggle matSuffix (click)="clearDesireDate()">
        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
    <!--[min]="minDate"-->
    <div [hidden]="inRange" class="date-validation">
      {{"common.validation.minDate" | translate}}!
    </div>
  </div>
</div>
